<template>
  <div :class="['retailer-search-result-fi', theme ? `retailer-search-result-fi--${theme}` : null]">
    <div class="retailer-search-result-fi__items">
      <retailer-search-result-item-fi
        v-for="item in slicedRetailers"
        :key="item.Retailer.RetailerId"
        :data="item"
        :show-stock="showStock"
        :show-distance="showDistance"
        :is-stocked="isStocked"
        :partner-type-logo="partnerTypeLogo"
        :theme="theme"
        @clicked="(val) => $emit('clicked', val)"
      />
    </div>

    <div
      v-if="totalItems > itemsPerPage"
      class="retailer-search-result-fi__pagination"
    >
      <pagination-progress-bar
        :pagination-page="currentPage"
        :pagination-total="totalPages"
        :progressbar-value="percentagePagination"
        @loadmore="nextPage"
      >
        <span>{{ $dict.get('dealer-Locator.Pagination', [currentItem, totalItems]) }}</span>
      </pagination-progress-bar>
    </div>
  </div>
</template>

<script>
import { PaginationProgressBar } from 'atoms';

import RetailerSearchResultItemFi from './retailer-search-result-item-fi/RetailerSearchResultItemFi';

export default {
  name: 'RetailerSearchResultFi',
  components: {
    PaginationProgressBar,
    RetailerSearchResultItemFi,
  },
  props: {
    retailers: {
      type: Array,
      required: true,
    },
    showStock: {
      type: Boolean,
      default: false,
    },
    isStocked: {
      type: Boolean,
      default: false,
    },
    partnerTypeLogo: {
      type: Object,
      default: null,
    },
    showDistance: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: null,
    },
  },
  emits: ['clicked'],
  data() {
    const itemsPerPage = 10;
    return {
      itemsPerPage,
      currentPage: 1,
    };
  },
  computed: {
    totalItems() {
      return this.retailers.length;
    },
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    percentagePagination() {
      return ((this.currentPage * this.itemsPerPage) / (this.totalPages * this.itemsPerPage)) * 100;
    },
    currentItem() {
      return Math.min(this.currentPage * this.itemsPerPage, this.retailers.length);
    },
    slicedRetailers() {
      const endOfPage = this.currentPage * this.itemsPerPage;
      const lastItem = Math.min(endOfPage, this.retailers.length);
      return this.retailers.slice(0, lastItem);
    },
  },
  methods: {
    nextPage() {
      this.currentPage += 1;
    },
  },
};
</script>

<style scoped lang="scss">
@import './retailer-search-result-fi';
</style>
